var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandPlan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.001,
    height: 100.001,
    viewBox: "0 0 100.001 100.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Land_-_Flaticon-2_1_",
    "data-name": "Search results for Land - Flaticon-2 (1)",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10063",
    "data-name": "Group 10063",
    transform: "translate(36.541 18.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10062",
    "data-name": "Group 10062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9867",
    "data-name": "Path 9867",
    d: "M200.544,93.3a13.316,13.316,0,0,0-7.622,2.382,1.479,1.479,0,0,0-.375,2.046,1.454,1.454,0,0,0,2.031.378,10.422,10.422,0,0,1,5.966-1.864,10.588,10.588,0,1,1-9.356,5.725,1.477,1.477,0,0,0-.621-1.985,1.455,1.455,0,0,0-1.97.626,13.682,13.682,0,0,0-1.513,6.252A13.461,13.461,0,1,0,200.544,93.3Z",
    transform: "translate(-187.084 -93.297)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10065",
    "data-name": "Group 10065",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10064",
    "data-name": "Group 10064",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9868",
    "data-name": "Path 9868",
    d: "M99.889,97.964l-14.415-34.9a1.46,1.46,0,0,0-1.348-.906H69.761A74.485,74.485,0,0,0,76.7,50.836a43.663,43.663,0,0,0,4.851-19.052,31.548,31.548,0,1,0-63.093,0A43.663,43.663,0,0,0,23.3,50.836a74.444,74.444,0,0,0,6.936,11.326H15.876a1.46,1.46,0,0,0-1.348.906L4.7,86.847a1.475,1.475,0,0,0,.787,1.924A1.453,1.453,0,0,0,7.4,87.978l1.4-3.393h9.943L13.593,97.058H3.651l1.494-3.616a1.475,1.475,0,0,0-.787-1.924,1.456,1.456,0,0,0-1.91.793L.113,97.964a1.48,1.48,0,0,0,.133,1.382A1.457,1.457,0,0,0,1.461,100h97.08a1.458,1.458,0,0,0,1.215-.655A1.481,1.481,0,0,0,99.889,97.964ZM21.375,31.784a28.626,28.626,0,1,1,57.251,0c0,6.669-2.3,17.325-12.939,30.9-.011.013-.02.026-.03.039q-.815,1.039-1.7,2.1A112.37,112.37,0,0,1,50,78.843,112.2,112.2,0,0,1,36.078,64.874q-.9-1.087-1.736-2.15l-.027-.034C23.677,49.111,21.375,38.455,21.375,31.784ZM16.85,65.105h9.943l-3.627,8.779H13.224Zm8.541,31.953,9.129-22.1,25.98,22.1Zm39.637,0h0L34.88,71.413a1.455,1.455,0,0,0-2.29.559L22.227,97.058h-5.47l5.527-13.379a1.48,1.48,0,0,0-.133-1.382,1.457,1.457,0,0,0-1.215-.655H10.019l1.989-4.814H24.14a1.46,1.46,0,0,0,1.348-.906L29.957,65.1h2.535q.66.829,1.346,1.658A110.194,110.194,0,0,0,49.107,81.9a1.452,1.452,0,0,0,1.788,0c.172-.134,2.492-1.955,5.8-5.07H73.23a1.472,1.472,0,0,0,0-2.943H59.7c2.025-2.051,4.238-4.443,6.464-7.121q.689-.829,1.347-1.658H83.152l3.626,8.779H79.072a1.472,1.472,0,0,0,0,2.943h8.922l1.989,4.814H59.89a1.461,1.461,0,0,0-1.368.957,1.479,1.479,0,0,0,.411,1.626L73.608,97.058h-8.58Zm13.036,0L63.8,84.585H91.2l5.153,12.473Z",
    transform: "translate(-0.001)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandPlan);
export default __webpack_public_path__ + "static/media/landPlan.5019e122ad9c74ee4076fe75271ad7f0.svg";
export { ForwardRef as ReactComponent };